export const accountColumns = [
  {
    id: "memberId",
    displayName: "Member Id",
    headerName: "Member Id",
    field: "memberId",
    flex: 1,
  },
  {
    id: "accountName",
    displayName: "Account name",
    headerName: "Account name",
    field: "accountName",
    flex: 1,
  },
  {
    id: "adult1",
    displayName: "Adult 1",
    headerName: "Adult 1",
    field: "adult1",
    flex: 1,
  },
  {
    id: "adult2",
    displayName: "Adult 2",
    headerName: "Adult 2",
    field: "adult2",
    flex: 1,
  },
  {
    id: "email1",
    displayName: "Email 1",
    headerName: "Email 1",
    field: "email1",
    flex: 1,
  },
  {
    id: "email2",
    displayName: "Email 2",
    headerName: "Email 2",
    field: "email2",
    flex: 1,
  },
  {
    id: "mobile1",
    displayName: "Mobile 1",
    headerName: "Mobile 1",
    field: "mobile1",
    flex: 1,
  },
  {
    id: "mobile2",
    displayName: "Mobile 2",
    headerName: "Mobile 2",
    field: "mobile2",
    flex: 1,
  },

  {
    id: "home1",
    displayName: "Home 1",
    headerName: "Home 1",
    field: "home1",
    flex: 1,
  },
  {
    id: "home2",
    displayName: "Home 2",
    headerName: "Home 2",
    field: "home2",
    flex: 1,
  },

  {
    id: "familyMembers",
    displayName: "Family Members",
    headerName: "Family Members",
    field: "familyMembers",
    flex: 1,
  },
  {
    id: "activeAddress",
    displayName: "Active Address",
    headerName: "Active Address",
    field: "activeAddress",
    flex: 1,
  },
  {
    id: "billingAddress",
    displayName: "Billing Address",
    headerName: "Billing Address",
    field: "billingAddress",
    flex: 1,
  },
  {
    id: "accountType",
    displayName: "Account Type",
    headerName: "Account Type",
    field: "accountType",
    flex: 1,
  },
  {
    id: "billingType",
    displayName: "Billing Type",
    headerName: "Billing Type",
    field: "billingType",
    flex: 1,
  },
  {
    id: "accountTags",
    displayName: "Account Tags",
    headerName: "Account Tags",
    field: "accountTags",
    flex: 1,
  }
];



export const contactColumns = [
  {
    id: "contactId",
    displayName: "Contact Id",
    headerName: "Contact Id",
    field: "contactId",
    flex: 1,
  },
  {
    id: "familyName",
    displayName: "Family Name",
    headerName: "Family Name",
    field: "familyName",
    flex: 1,
  },
  {
    id: "firstName",
    displayName: "First Name",
    headerName: "First Name",
    field: "firstName",
    flex: 1,
  },
  {
    id: "lastName",
    displayName: "Last Name",
    headerName: "Last Name",
    field: "lastName",
    flex: 1,
  },
  {
    id: "mobile",
    displayName: "Mobile",
    headerName: "Mobile",
    field: "mobile",
    flex: 1,
  },
  {
    id: "homePhone",
    displayName: "Home Phone",
    headerName: "Home Phone",
    field: "homePhone",
    flex: 1,
  },
  {
    id: "email",
    displayName: "Email",
    headerName: "Email",
    field: "email",
    flex: 1,
  },
  {
    id: "address",
    displayName: "Address",
    headerName: "Address",
    field: "address",
    flex: 1,
  },
  {
    id: "contactTags",
    displayName: "Contact Tags",
    headerName: "Contact Tags",
    field: "contactTags",
    flex: 1,
  }
];
